import React from "react";
import "./style.scss";

const HeaderSpace = () => {
    return <div className="HeaderSpace"></div>
}

export default HeaderSpace;